module.exports = __webpack_public_path__ + "EmotionalCropped-53d619fd3fa7151da29442d0a9cb3a8c.png";